<!--项目结算单列表-->
<template>
  <div v-if="quotationList.length" class="quotation-list">
    <!-- <i-form> -->

    <div class="quotation-form-group" v-if="isClient">
      <div v-for="(item, index) in quotationList" :key="index">
        <div
          class="new-all-btn"
          :class="index == 0 ? 'new-all-btn' : 'big-all-btn'"
        >
          <h3 v-if="index == 0" style="min-width:100px">项目结算单</h3>
 
          <div class="all-btn">
            <!-- 项目结算单列表 -->
            <!-- style="margin-bottom:20px" -->
            <span class="billMoney" v-if="billMoneyShow && index == 0"
              >（本次开票申请总金额（含税）：￥{{
                twoFixed(billMoney)
              }}）</span
            >
            <!-- <Checkbox @on-change="multipleChange">申请多个开票</Checkbox> -->
            <template v-if="!disableControl">
               <!-- <button>
                {{item}}
              </button> -->
              <Button
                type="primary"
                @click="edit(item.baojiadanId,item)"
                v-if="item.new_baojiadan_edit == 'show' ? true : false"
                :class="item.new_baojiadan_edit == 'show' ? 'blue' : 'gray'"
                class="button"
                 :loading="item.editClientBtn"
              >
                <Icon type="compose"></Icon> 编辑
              </Button>
              <Button
                type="primary"
                @click="exportbaojiadan(item.baojiadanId,item)"
                 :loading="item.exportClientBtn"
                class="button"
              >
                <Icon type="archive"></Icon> 导出
              </Button>
            </template>
            <Poptip
              confirm
              transfer
              title="确定作废该报价单？"
              placement="bottom"
              @on-ok="deleteQuotation(item.baojiadanId)"
              ok-text="确定"
              cancel-text="取消"
            >

              <Button
                type="primary"
                class="button"
               
              v-if="item.new_baojiadan_delete == 'show' ? true : false"
                :class="item.new_baojiadan_delete == 'show' ? 'blue' : 'gray'"
              >
                <Icon type="trash-a"></Icon> 作废
              </Button>
                 
                <!-- :disabled="item.new_baojiadan_delete == 'show' ? false : true" -->
               <!-- v-if="item.new_baojiadan_delete == 'show' ? true : false" -->
               <!-- :disabled="item.new_baojiadan_delete == 'show' ? false : true"
                          :class="item.new_baojiadan_delete == 'show' ? 'blue' : 'gray'" -->
            </Poptip>
            <i-col  v-if="item.flowState !== '0' && !disableControl">
              <Poptip
                v-if="item.flowState == 3 && item.new_kaipiao_audit == 'show'"
                confirm
                transfer
                title="是否通过审核？"
                placement="bottom"
                @on-ok="kaipiao(item.kfId,item)"
                @on-cancel="changeModal(item.kfId)"
                ok-text="通过"
                cancel-text="不通过"
                style="width: 100%"
                
              >
                <Button type="primary" class="button"  :loading="item.applyOneBtn"
                  >审核</Button
                >
              </Poptip>
             
              <Button
                v-else
                type="primary"
                :disabled="!billing[index].billingBtnDisable"
                :class="billing[index].billingBtnDisable ? 'blue' : 'gray'"
                class="button"
                
                 :loading="item.bilingBtnLoading"
                @click="billingApply(item.baojiadanId, item.priceMeal,item)"
                >{{ billing[index].billingBtnText }}</Button
              >
            </i-col>
              <Button
            v-if="item.new_kaipiao_money == 'show'"
            type="primary"
            class="button"
            @click="fukuan(item.kfId,item)"
            :loading="loadingFukuanBtn"
          >已支付</Button>
           <Button
            v-if="item.flowState==4"
            type="primary"
            class="button"
            @click="goDayin(item)">
            打印<!--  v-if="item.flowState==4" --></Button>
          </div>
        </div>

        <div>
          <!-- itemContent循环的它 -->
         
          <simple-quotation
            class="detail-quotation"
            :itemContent="item"
            :id="item.baojiadanId"
            :state="item.new_baojiadan_edit"
            :tax="formValue.formInfo[0].formContent.contractsInfo.secondModifyInfo.taxRate.value === ''? 6
                : formValue.formInfo[0].formContent.contractsInfo
                    .secondModifyInfo.taxRate.value
            "
          ></simple-quotation>
          
        </div>
      </div>
    </div>
    <div class="quotation-form-group" v-else>
      <div v-for="(item, index) in quotationList" :key="index">
        <div
          class="new-all-btn"
          :class="index == 0 ? 'new-all-btn' : 'big-all-btn'"
        >
          <h3 v-if="index == 0" style="min-width:100px">供应商结算单</h3>
          <div class="all-btn">
            <!-- :class="index==0?'':'big-all-btn'" -->
            <template v-if="!disableControl">
              <Button
                type="primary"
                @click="edit(item.baojiadanId,item)"
                v-if="item.new_baojiadan_edit == 'show' ? true : false"
                :class="item.new_baojiadan_edit == 'show' ? 'blue' : 'gray'"
                class="button"
                :loading="item.editClientBtn"
              >
                <Icon type="compose"></Icon> 编辑
              </Button>
              <Button
                type="primary"
                @click="exportbaojiadan(item.baojiadanId,item)"
                class="button"
                :loading="item.exportClientBtn"
              >
                <Icon type="archive"></Icon> 导出
              </Button>
            </template>
            <Poptip
              confirm
              transfer
              title="确定作废该报价单？"
              placement="bottom"
              @on-ok="deleteQuotation(item.baojiadanId)"
              ok-text="确定"
              cancel-text="取消"
            >
              <Button
                type="primary"
                class="button"
                v-if="item.new_baojiadan_delete == 'show'"
                :class="item.new_baojiadan_delete == 'show' ? 'blue' : 'gray'"
              >
                <Icon type="trash-a"></Icon> 作废
              </Button>
           
            </Poptip>
          </div>
        </div>

        <div>
          <simple-quotation
            class="detail-quotation"
             :itemContent="item"
            :id="item.baojiadanId"
            :state="item.new_baojiadan_edit"
            :tax="
              formContent.secondModifyInfo.taxRate.value === ''
                ? 6
                : formContent.secondModifyInfo.taxRate.value
            "
          ></simple-quotation>
        </div>
      </div>
    </div>
    <!-- </i-form> -->
    <Modal
      v-model="showModal"
      class-name="vertical-center-modal examine-modal"
      ok-text="提交"
      width="480px"
      :closable="false"
      :loading="true"
      :mask-closable="!rejectedReason"
    >
   <i-input
        type="textarea"
        v-model="modalValue"
        :autosize="{ minRows: 5 }"
        placeholder="填写不通过的理由"
      ></i-input>
      <span
        class="words-count"
        :class="{ 'over-length': modalValue.length > 1000 }"
        >{{ modalValue.length }}/1000</span
      >
      <div slot="footer" class="custom-footer">
        <Button
          type="primary"
          size="large"
          class="ok"
          :loading="rejectedReason"
          @click.native="noPassKaipiao()"
          :disabled="modalValue.length > 1000 || modalValue.length == 0"
          >提交</Button
        >
      </div>
    </Modal>
    <Modal
      v-model="showProjectList"
      title="Common Modal dialog box title"
      @on-ok="ok"
      @on-cancel="cancel"
      width="80%"
      height="80%"
    >
      <div class="finance">
        <!-- <simple-quotation v-if="showProjectList"    :id='id' :state="state" :tax="tax"></simple-quotation> -->
      </div>
    </Modal>
    <toast :msg="toastMsg" :is-toast="isToast"></toast>
  </div>
</template>
<script>
import { Task } from "../../../API/api";
import Toast from "../../popup/Toast";
import { thousandSplit } from "../../../util/util.js";
import Quotation from "../display/quotation.vue";
import SimpleQuotation from "../display/simpleQuotation.vue";
export default {
  name: "quotation-list",
  components: {
    Toast,
    Quotation,
    SimpleQuotation,
  },
  props: {
    taskInfo: {
      type: [Object, Array],
      default() {
        return {};
      },
    },
    projectInfo: {
      type: [Object, Array],
      default() {
        return {};
      },
    },
    formValue: {
      type: [Object, Array],
      default() {
        return {};
      },
    },
    changeBaojiadan: {
      type: [Boolean],
    },
    isClient: {
      type: Boolean,
      default() {
        return false;
      },
    },
    formContent: {
      type: [Object, Array],
      default() {
        return {};
      },
    },
    activeVer:{
        type:[String,Number] ,
    }
  },
  data() {
    return {
      editClientBtn:false,
      exportClientBtn:false,
      toastMsg: "",
      isToast: false,
      showModal: false,
      nopassId: null,
      modalValue: "",
      billing: [],
      showInvoice: false,
      multipleSelect: false,
      billMoneyShow: false,
      billMoney: "",
      quotationList: [],
      showProjectList: false,
      // activeVer: 0,
      rejectedReason:false,
    };
  },
  computed: {
    disableControl() {
      return this.$route.name === "clientContract";
    },
  },
  methods: {
 
    ok() {
      this.$nextTick(() => {
        this.showProjectList = false;
      });
    },
    cancel() {
      // this.showProjectList=false;
    },
    twoFixed(v) {
      let m = parseFloat(v);
      return isNaN(m) ? "" : thousandSplit(m.toFixed(2) + "");
    },
    changeModal(id) {
      this.showModal = true;
      this.nopassId = id;
    },
    viewQuotation(baojiadanId, state) {
      let tax;
      if (this.isClient) {
        tax =
          this.formValue.formInfo[0].formContent.contractsInfo.secondModifyInfo
            .taxRate.value === ""
            ? 6
            : this.formValue.formInfo[0].formContent.contractsInfo
                .secondModifyInfo.taxRate.value;
      } else {
        tax =
          this.formContent.secondModifyInfo.taxRate.value === ""
            ? 6
            : this.formContent.secondModifyInfo.taxRate.value;
      }

      this.id = baojiadanId;
      this.state = state;
      this.tax = tax;
      // this.$router.push({
      //    path: "/tasks/info/" + baojiadanId,
      //         query: {
      //           state,
      //           tax,
      //         }
      // }

      // )

      this.showProjectList = true;
    },
    multipleChange() {
      this.$router.push({
        path:
          "/tasks/add/" +
          this.projectInfo.customerId +
          "/" +
          this.projectInfo.projectId +
          "/" +
          7 +
          "/" +
          19,
        query: {
          id: this.formValue.info.id,
        },
      });
    },
    deleteQuotation(id) {
      const params = {
        id,
        state: 12,
      };

      this.$http
        .post(Task.financeAudit, this.qs.stringify(params), {
          headers: { Authorization: "Bearer " + this.$cookie.get("token") },
        })
        .then((res) => {
          let _data = res.data;
          if (_data.retCode !== 0) {
            this.isToast = true;
            this.toastMsg = _data.retMsg;
          } else if (_data.retCode === 100014) {
            this.$cookie.delete("token");

            this.$router.push("/");
          } else {
            this.isToast = true;
            this.toastMsg = "作废成功";
            this.getQuotationList();
          }
          setTimeout(() => {
            this.isToast = false;
          }, 1500);
        });
    },
    goDayin(item){
      const {priceNoTax,priceTotal,taskName}=item;
      const baseInfo=this.formValue.formInfo[this.activeVer].formContent.contractsInfo;//提取出来公共的部分
      const taxRate=baseInfo.secondModifyInfo.taxRate.value === ''? 6: baseInfo.secondModifyInfo.taxRate.value
      let partA,partB;
      //甲方信息
    {
      const basicInfoParkA=baseInfo.partyA;
      console.log(baseInfo,'basicInfoParkA')
      const openBank= basicInfoParkA.openBank.value;
      const accountTaxNum=basicInfoParkA.accountTaxNum.value;
      const openAccount= basicInfoParkA.openAccount.value;
      const partA_Name=basicInfoParkA.name.value
      console.log(partA_Name,'partA_Name----')
      partA={partA_Name,openBank,accountTaxNum,openAccount};
    }
     {
      const basicInfoParkB=baseInfo.partyB;
      const openBank= basicInfoParkB.openBank.value;
      const accountTaxNum= basicInfoParkB.accountTaxNum.value;
      const openAccount= basicInfoParkB.openAccount.value;
      const partB_Name=basicInfoParkB.name.value
      partB={partB_Name,openBank,accountTaxNum,openAccount};
    }
      console.log(partB,'partA')
      // const partB=JSON.parse(baseInfo.partyB.name.value);
      const printData={
      taskName:baseInfo.basicInfo.contractName.value,//合同名称
      hetongPriceTotal:baseInfo.basicInfo.money.value,//合同金额
      partA,
      partB,
      priceNoTax,
      priceTotal,
      taskName,//合同名称
      taxRate,//税率
      };
       const routeData = this.$router.resolve({
        name: "WindowPrint",
        query: {
          type: "statements",
          fromtime: this.month,
          totime: this.month,
          // printData:
        },
        
      });
      sessionStorage.removeItem('printData');
      sessionStorage.setItem('printData',JSON.stringify(printData))
      console.log(printData,'printData',item,'item000000')
      window.open(routeData.href, "_blank");

    },
    fukuan(id,item) {
      item.loadingFukuanBtn=true;
      this.$forceUpdate()
      let formData = {
        kfId: id,
        flowState: 7,
      };
      this.$http
        .post(Task.hetongkfmoney, this.qs.stringify(formData), {
          headers: { Authorization: "Bearer " + this.$cookie.get("token") },
        })
        .then((res) => {
          let _data = res.data;
          if (_data.retCode !== 0) {
            this.isToast = true;
            this.toastMsg = _data.retMsg;
             item.loadingFukuanBtn=false;
          } else if (_data.retCode === 100014) {
            this.$cookie.delete("token");

            this.$router.push("/");
          } else {
            this.billing = [];
            this.isToast = true;
            this.toastMsg = "提交成功";
            item.loadingFukuanBtn=false;
            this.$emit("refresh");
            this.getQuotationList();
          }
          setTimeout(() => {
            this.isToast = false;
          }, 1500);
        });
    },
    billingApply(baojiadanId, priceMeal,item) {
      console.log(
                    this.formValue.formInfo[0].formContent.contractsInfo.partyA
                  ,'--------123456')
                  // value: JSON.parse(
                  //   this.formValue.formInfo[0].formContent.contractsInfo.partyA
                  //     .name.value
                  // ).customerName,
                  let partyAName=this.formValue.formInfo[0].formContent.contractsInfo.partyA.name.value
                  //环胜电子商务（上海）有限公司
                  console.log(typeof(partyAName),'typeof(partyAName)')
                  if(typeof(partyAName)=='string'){

                  }else{
                    partyAName=JSON.parse(
                    this.formValue.formInfo[0].formContent.contractsInfo.partyA
                      .name.value
                  ).customerName
                  }
                  console.log(partyAName,'partyAName-----')
      let formData = {
        projectId: this.formValue.info.projectId,
        productId: this.formValue.info.productId,
        toolkitId: 19,
        hetongId: this.formValue.info.id,
        baojiadanId: [baojiadanId],
        priceMeal: priceMeal,
        operationInfo: [
          {
            operationId: JSON.parse(localStorage.getItem("userInfo")).id,
          },
        ],
        taskName:
          this.formValue.formInfo[0].formContent.contractsInfo.basicInfo
            .contractName.value,
        taskForm: {
          billingInfo: [
            {
              basicInfo: {
                contractId: {
                  value: String(this.formValue.info.id),
                  toastMsg: "请选择合同",
                },
                quotationId: {
                  value: String(baojiadanId),
                  toastMsg: "请选择项目结算单",
                },
                totalMoney: {
                  value:
                    this.formValue.formInfo[0].formContent.contractsInfo
                      .basicInfo.money.value,
                  toastMsg: "请输入金额",
                },
                // afterTaxMoney: {
                //   value : '',
                //   toastMsg : ''
                // },
                
                taxRate: {
                  value: "6%",
                  toastMsg: "",
                },
                company: {
                  value: partyAName,
                  toastMsg: "",
                },
                contactPerson: {
                  value:
                    this.formValue.formInfo[0].formContent.contractsInfo.partyA
                      .contactPerson.value,
                  toastMsg: "",
                },
                accountName: {
                  value:
                    this.formValue.formInfo[0].formContent.contractsInfo.partyA
                      .accountName.value,
                  toastMsg: "",
                },
                taxNumber: {
                  value:
                    this.formValue.formInfo[0].formContent.contractsInfo.partyA
                      .accountTaxNum.value,
                  toastMsg: "",
                },
                openBank: {
                  value:
                    this.formValue.formInfo[0].formContent.contractsInfo.partyA
                      .openBank.value,
                  toastMsg: "",
                },
                openAccount: {
                  value:
                    this.formValue.formInfo[0].formContent.contractsInfo.partyA
                      .openAccount.value,
                  toastMsg: "",
                },
                companyMobile: {
                  value:
                    this.formValue.formInfo[0].formContent.contractsInfo.partyA
                      .companyMobile.value,
                  toastMsg: "",
                },
                companyAddress: {
                  value:
                    this.formValue.formInfo[0].formContent.contractsInfo.partyA
                      .companyAddress.value,
                  toastMsg: "",
                },
              },
            },
          ],
          operationInfo: [
            {
              operationId: null,
              // inspectorId: [],
              content: {
                isMulti: "true",
                canMore: false,
              },
            },
          ],
        },
      };
      item.bilingBtnLoading=true;
this.$forceUpdate();
      this.$http
        .post(Task.add, this.qs.stringify(formData), {
          headers: { Authorization: "Bearer " + this.$cookie.get("token") },
        })
        .then((res) => {
          let _data = res.data;
          if (_data.retCode !== 0) {
            this.isToast = true;
            this.toastMsg = _data.retMsg;
          } else if (_data.retCode === 100014) {
            this.$cookie.delete("token");

            this.$router.push("/");
          } else {
            this.billing = [];
            this.isToast = true;
            this.toastMsg = "提交成功";
            this.$emit("refresh");
            this.getQuotationList();
            
          }
          setTimeout(() => {
            this.isToast = false;
          }, 1500);
     item.bilingBtnLoading=false;
        });
    },
    kaipiao(id,item) {
      item.applyOneBtn=true;
      this.$forceUpdate();
      let formData = {
        id: id,
        state: 6,
      };
      this.$http
        .post(Task.financeAudit, this.qs.stringify(formData), {
          headers: { Authorization: "Bearer " + this.$cookie.get("token") },
        })
        .then((res) => {
          let _data = res.data;
          if (_data.retCode !== 0) {
            this.isToast = true;
            this.toastMsg = _data.retMsg;
            item.applyOneBtn=false;
          } else if (_data.retCode === 100014) {
            this.$cookie.delete("token");

            this.$router.push("/");
          } else {
            this.billing = [];
            this.isToast = true;
            this.toastMsg = "提交成功";
            this.$emit("refresh");
            this.getQuotationList();
             item.applyOneBtn=false;
          }
          setTimeout(() => {
            this.isToast = false;
           ;
          }, 1500);
        });
    },
    noPassKaipiao() {
      let formData = {
        id: this.nopassId,
        state: 7,
        reason: this.modalValue,
      };
      this.rejectedReason=true;
      this.$http
        .post(Task.financeAudit, this.qs.stringify(formData), {
          headers: { Authorization: "Bearer " + this.$cookie.get("token") },
        })
        .then((res) => {
          this.rejectedReason=false;
          let _data = res.data;
          if (_data.retCode !== 0) {
            this.isToast = true;
            this.toastMsg = _data.retMsg;
          } else if (_data.retCode === 100014) {
            this.$cookie.delete("token");

            this.$router.push("/");
          } else {
            this.billing = [];
            this.isToast = true;
            this.toastMsg = "提交成功";
            this.modalValue = "";
            this.showModal = false;
            this.$emit("refresh");
            this.getQuotationList();
          }
          setTimeout(() => {
            this.isToast = false;
          }, 1500);
        });
    },
    exportbaojiadan(id,item) {
      console.log('id-=====导出')
      item.exportClientBtn=true;
      this.$forceUpdate()
      console.log(item,'item===')
      let formData = {
        baojiadanId: id,
      };
      this.$http
        .post(Task.exportbaojiadan, this.qs.stringify(formData), {
          headers: { Authorization: "Bearer " + this.$cookie.get("token") },
        })
        .then((res) => {
          item.exportClientBtn=false;
      this.$forceUpdate()
          let url = res.data.retData.download_url;
          window.open(url);
        });
    },
    edit(id,item) {
      item.editClientBtn=true;
      this.$forceUpdate();
      let tax;
      if (this.isClient) {
        tax =
          this.formValue.formInfo[0].formContent.contractsInfo.secondModifyInfo
            .taxRate.value === ""
            ? 6
            : this.formValue.formInfo[0].formContent.contractsInfo
                .secondModifyInfo.taxRate.value;
      } else {
        tax =
          this.formContent.secondModifyInfo.taxRate.value === ""
            ? 6
            : this.formContent.secondModifyInfo.taxRate.value;
      }
      
      this.$router.push({
        path:
          "/tasks/edit/" +
          id +
          "/" +
          this.projectInfo.customerId +
          "/" +
          this.projectInfo.projectId,
        query: {
          tax,
        },
      });
    },
    audit(baojiadanId) {
      this.$router.push({
        path:
          "/tasks/add/" +
          this.projectInfo.customerId +
          "/" +
          this.projectInfo.projectId +
          "/" +
          this.taskInfo.productId +
          "/" +
          19,
        query: {
          contractId: this.taskInfo.id,
          quotationId: baojiadanId,
        },
      });
    },
    getQuotationList() {
      let formData = {
        hetongId: this.taskInfo.id,
      };
      this.$http
        .post(Task.contactbaojiadanlist, this.qs.stringify(formData), {
          headers: { Authorization: "Bearer " + this.$cookie.get("token") },
        })
        .then((res) => {
          var billingBtnDisable, billingBtnText;
          this.quotationList = res.data.retData.data;
          this.billMoney = res.data.retData.kfPriceMealTotalFlowState3;
          let billMoneyLength = 0;
          this.billMoneyShow = false;
           sessionStorage.setItem('quotationListLength',this.quotationList.length);
          this.quotationList.length &&
            this.quotationList.forEach((element) => {
              element.editClientBtn=false;
              element.exportClientBtn=false;
              element.bilingBtnLoading=false;
              element.applyOneBtn=false;
              element.loadingFukuanBtn=false;
              if (element.invoiceNo) {
                //判断是否展示关联发票
                this.showInvoice = true;
              }
              if (
                element.flowState == 2 &&
                element.new_kaipiao_apply == "show"
              ) {
                this.multipleSelect = true;
              }
              if (element.flowState == 3) {
                billMoneyLength += 1;
              }

              switch (
                element.flowState //开票状态
              ) {
                case "0":
                  billingBtnText = "申请开票";
                  billingBtnDisable = false;
                  break;
                case "2":
                  if (element.new_kaipiao_apply == "show") {
                    billingBtnText = "申请开票";
                    billingBtnDisable = true;
                  } else {
                    billingBtnText = "申请开票";
                    billingBtnDisable = false;
                  }
                  break;
                case -4:
                  if (element.new_kaipiao_apply == "show") {
                    billingBtnText = "申请开票";
                    billingBtnDisable = true;
                  } else {
                    billingBtnText = "审批拒绝";
                    billingBtnDisable = false;
                  }
                  break;
                case 3:
                  billingBtnText = "开票中";
                  billingBtnDisable = false;
                  break;
                case 4:
                  billingBtnText = "已开票";
                  billingBtnDisable = false;
                  break;
                case 7:
                  billingBtnText = "已开票";
                  billingBtnDisable = false;
                  break;
              }
              this.billing.push({
                billingBtnText: billingBtnText,
                billingBtnDisable: billingBtnDisable,
              });
            });
          if (billMoneyLength > 1) this.billMoneyShow = true;
        });
    },
  },
  created() {
    this.getQuotationList();
  },
  mounted() {
  },
};
</script>
<style lang="less" scoped>
.new-all-btn {
  display: flex;
  justify-content: space-between;
}
.quotation-form-group {
  border: none;

  > div {
    background-color: white;
    border-bottom: none;
    > h3 {
      display: inline-block;
    }
  }
}
.quotation-list {
  background-color: none;
}
.all-btn {
  display: inline-flex;
  justify-content: flex-end;
  width: 1295px;
}
.big-all-btn {
  // width: 100%;
  display: flex;
  justify-content: flex-end;
}
.row {
  border-bottom: 1px solid #ced4da;
}
.row:last-child {
  border: none;
}
.border-right {
  border-right: 1px solid #ced4da;
}
.button {
  font-size: 14px;
  // color: #2d8ef8;
  // height: 53px;
  // text-align: center;
  // width: 100%;
  // width: 88px;
  height: 36px;
  background: #2d8ef8;
  border-radius: 4px;
  margin-left: 10px;
  margin-bottom: 2px;
  &disabled{
    background-color: #ced4da;
  }
  // margin-top: 20px;
}
.pay {
  font-size: 14px;
  height: 53px;
  line-height: 53px;
  text-align: center;
  border-left: 1px solid #ced4da;
}
.gray {
  color: #adb5bd;
  background-color: #f7f7f7;
}
.blue {
  // color: #2d8ef8;
}
.flex {
  display: flex;
  justify-content: center;
  align-items: center;
}
.label {
  font-size: 14px;
  text-align: center;
  border-right: 1px solid #ced4da;
  height: 53px;
  // line-height: 53px;
}
.smBaojiadantitle,
.baojiadantitle {
  width: 88px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  height: 26px;
  line-height: 26px;
  // padding: 0 5px;
}
.baojiadantitle {
  width: 400px !important;
}
.billMoney {
  color: #ed3f14;
  margin-left: 20px;
}
.quotation-child {
  width: 100px;
  height: 100px;
  background: black;
}
.detail-quotation {
  // margin-bottom: 10px;
}
</style>




